import { Stack, styled } from '@ltvco/refresh-lib/theme';

import { ChatPageMessagesContainer } from 'components/DeepSearch/components/components';

export const LayoutColumnStack = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'isColumnOpen' && prop !== 'isMobile',
})<{ isColumnOpen: boolean; isMobile: boolean }>(
  ({ isColumnOpen, isMobile }) => ({
    width: '100%',
    height: '100%',
    minWidth: 0,
    overflow: 'hidden',
    position: 'relative',
    flexDirection: isColumnOpen ? 'row' : 'column',
    ...(isColumnOpen && !isMobile && { gap: '24px' }),
  })
);

export const MessagesArea = styled(ChatPageMessagesContainer, {
  shouldForwardProp: (prop) => prop !== 'isColumnOpen' && prop !== 'isMobile',
})<{ isColumnOpen: boolean; isMobile: boolean }>(
  ({ isColumnOpen, isMobile }) => ({
    width: isColumnOpen && !isMobile ? '60%' : '100%',
    height: isColumnOpen ? '98%' : '100%',
    minWidth: 0,
    overflow: 'hidden',
    ...(isColumnOpen && isMobile && { width: 0, flexShrink: 1 }),
  })
);
